import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./manager_code_for_scanned_items_mode.js";
//#region src/manager_code_for_scanned_items_mode_helper.ts
var manager_code_for_scanned_items_mode_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(mode) {
	switch (mode) {
		case "never": return "Never";
		case "removal": return "On scanned item removal only";
		case "removal-and-menu-exit": return "On scanned item removal and menu exit";
	}
}
//#endregion
export { manager_code_for_scanned_items_mode_helper_exports, name };

//# sourceMappingURL=manager_code_for_scanned_items_mode_helper.js.map